import * as React from 'react';

import { enumUnit, Unit } from '@rematter/frontend-lib-api-client';
import { cn, shortenUnit } from '@rematter/ui-web';

import { FinanceLineItemData, FinanceLineItemErrors } from '../types';

import { UnitFieldCell as UnitFieldCellComponent } from '~/shared/components/line-items';

interface UnitFieldCellProps {
  lineItem: FinanceLineItemData;
  onUpdate: (id: string, updates: Partial<FinanceLineItemData>) => void;
  disabled?: boolean;
  errors?: FinanceLineItemErrors;
}

export const UnitFieldCell: React.FC<UnitFieldCellProps> = ({
  lineItem,
  onUpdate,
  disabled = false,
  errors,
}) => {
  const handleChange = React.useCallback(
    (value?: Unit) => {
      onUpdate(lineItem.id, { unit: value || null });
    },
    [lineItem.id, onUpdate],
  );

  return (
    <UnitFieldCellComponent
      value={(lineItem.unit as Unit) || enumUnit.Pounds}
      onChange={handleChange}
      disabled={disabled}
      formatLabel={shortenUnit}
      error={errors?.unit}
      className={cn('@UnitFieldCell')}
    />
  );
};
